import axios from 'axios';
import {toast} from "react-toastify";
import config from "../config/apiService.json";
import logout from "./logout";

const {baseApiEndPoint} = config;

// Get the value of the access token cookie
export const getAccessTokenValue = () => {
    const cookieString = document.cookie;
    const cookieValue = cookieString.length > 0 && cookieString
        .split('; ')
        .find(row => row.startsWith('access_token='))
        ?.split('=')[1];

    return cookieValue;
}

// check the access token exist in cookie or not
export const checkAccessTokenCookie = () => {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        const [name, value] = cookies[i].split("=");
        if (name === "access_token") {
            return getAccessTokenValue(); // The cookie exists
        }
    }
    return false; // The cookie doesn't exist
};

// Set the headers for the API request
export const headers = {
    'Authorization': `Bearer ${getAccessTokenValue()}`
};

export const postMethod = async (url, obj) => {
    // Make the API request using Axios
    try {
        toast.info("Data Uploading...!", {autoClose: false});
        const {data} = await axios.post(`${baseApiEndPoint}${url}`, obj, {headers});
        const {success} = data;
        const {payload} = data;
        toast.dismiss();

        if (!success) {
            const {message} = data;
            toast.error(message);
        }

        return payload;
    } catch (e) {
        toast.dismiss();
        toast.error(e.response.error);

        if (e.response.status === 401) logout();
    }
}

export const patchMethod = async (url, obj) => {
    try {
        // Make the API request using Axios
        toast.info("Data Updating...!", {autoClose: false});
        const {data} = await axios.patch(`${baseApiEndPoint}${url}`, obj, {headers});
        const {success} = data;
        toast.dismiss();

        if (!success) {
            const {message} = data;
            toast.error(message);
            return false;
        }

        return true;
    } catch (e) {
        toast.dismiss();
        toast.error(e.response.data.error);

        if (e.response.status === 401) logout();
    }
}

export const deleteMethod = async (url) => {
    try {
        // Make the API request using Axios
        const {data} = await axios.delete(`${baseApiEndPoint}${url}`, {headers});
        const {success} = data;

        if (!success) {
            const {message} = data;
            toast.error(message);
            return false;
        }
        return true;
    } catch (e) {
        toast.dismiss();
        toast.error(e.response.data.error);

        if (e.response.status === 401) logout();
    }
}
